/* Accessible explanations for breed filters and card badges. */
(() => {
  const root = document.querySelector('[data-vmrasse-root]');
  if (!root) return;
  const bubble = document.createElement('div');
  bubble.className = 'vmrasse__tooltip-bubble';
  bubble.id = 'vmrasse-tooltip';
  bubble.setAttribute('role', 'tooltip');
  bubble.hidden = true;
  document.body.appendChild(bubble);
  let current;
  const hide = () => {
    if (current) current.removeAttribute('aria-describedby');
    bubble.hidden = true;
    current = null;
  };
  const show = (el) => {
    const text = el.getAttribute('data-tooltip');
    if (!text) return;
    hide();
    current = el;
    bubble.textContent = text;
    bubble.hidden = false;
    el.setAttribute('aria-describedby', bubble.id);
    const rect = el.getBoundingClientRect();
    const width = bubble.offsetWidth;
    const left = Math.max(12, Math.min(innerWidth - width - 12, rect.left + rect.width / 2 - width / 2));
    const below = rect.top < bubble.offsetHeight + 20;
    bubble.style.left = `${left}px`;
    bubble.style.top = `${below ? rect.bottom + 9 : rect.top - bubble.offsetHeight - 9}px`;
  };
  root.querySelectorAll('[data-tooltip]').forEach((el) => {
    if (!el.matches('button, a, [tabindex]')) el.tabIndex = 0;
    el.addEventListener('mouseenter', () => show(el));
    el.addEventListener('mouseleave', hide);
    el.addEventListener('focus', () => show(el));
    el.addEventListener('blur', hide);
    if (!el.matches('button, a')) el.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      show(el);
    });
  });
  document.addEventListener('pointerdown', (event) => { if (current && !current.contains(event.target) && !bubble.contains(event.target)) hide(); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') hide(); });
  window.addEventListener('scroll', hide, { passive: true });
})();
